
<section id="features" class="features">
  <div class="features__pre-title">
    <p>{{ "features.pre-title" | transloco }}</p>
  </div>
  <h2 class="features__title">{{ "Simplify your photography activity" | transloco }}</h2>
  <p class="features__subtitle">
    {{ "Shutterflow combines powerful tools to help you focus on what matters for you" | transloco }}
  </p>

  <div class="features__list">
    <div class="feature">
      <div class="feature__header">
        <div class="feature__icon">
          <i class="fa-solid fa-user-check"></i>
        </div>
        <h3 class="feature__name">{{ 'features.client_booking_management' | transloco }}</h3>
      </div>

      <div class="feature__advantages">
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.client_booking_management.advantage1' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.client_booking_management.advantage2' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.client_booking_management.advantage3' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.client_booking_management.advantage4' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.client_booking_management.advantage5' | transloco }}</p>
        </div>
      </div>
    </div>

    <div class="feature">
      <div class="feature__header">
        <div class="feature__icon">
          <i class="fa-solid fa-images"></i>
        </div>
        <h3 class="feature__name">{{ 'features.photo_delivery_experience' | transloco }}</h3>
      </div>

      <div class="feature__advantages">
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.photo_delivery_experience.advantage1' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.photo_delivery_experience.advantage2' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.photo_delivery_experience.advantage3' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.photo_delivery_experience.advantage4' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.photo_delivery_experience.advantage5' | transloco }}</p>
        </div>
      </div>
    </div>

    <div class="feature">
      <div class="feature__header">
        <div class="feature__icon">
          <i class="fa-solid fa-rocket"></i>
        </div>
        <h3 class="feature__name">{{ 'features.business_growth_optimization' | transloco }}</h3>
      </div>

      <div class="feature__advantages">
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.business_growth_optimization.advantage1' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.business_growth_optimization.advantage2' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.business_growth_optimization.advantage3' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.business_growth_optimization.advantage4' | transloco }}</p>
        </div>
        <div class="feature__advantages-advantage">
          <i class="fa-solid fa-circle-check"></i>
          <p>{{ 'features.business_growth_optimization.advantage5' | transloco }}</p>
        </div>
      </div>
    </div>
  </div>

  <a class="button button--large"
     [routerLink]="'/register'"
  >
    {{ 'landing.try-now' | transloco }}
    <i class="fa-solid fa-arrow-right"></i>
  </a>
</section>
